import axios from "axios";
import store from "../index";
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
const state = {
    payments:[],
    payment : [],
    index:'',
    sortBy:'',
    sortDesc:''



};

const getters = {
    getPayments: state => {
        return state.payments;
    },
    getPayment: state => {
        return state.payment;
    },
    getIndex: state => {
        return state.index;
    },
    getSortBy: state => {
        return state.sortBy;
    },
    getSortDesc: state => {
        return state.sortDesc;
    },



};

const actions = {

    asyncFetchData : async (context,settings) => {

        const {sortBy, sortDesc, page, itemsPerPage} = settings.options;
        let url = "paymentmethods";

        context.commit('setSortDesc', sortDesc[0]);
        context.commit('setSortBy', sortBy[0]);
        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "sortBy": context.rootGetters['payments/getSortBy'],
                    'sortDesc': context.rootGetters['payments/getSortDesc'],
                    'page': page,
                    'itemsPerPage': itemsPerPage,
                    'filters': (settings.filters)?settings.filters:'',
                    'search': settings.search
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);
                context.commit('setPayments', res.data.data);
                return res.data.pagination
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },
    fetchLists : async (context,settings) => {


        let url = "paymentmethods/lists";

        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {

                //console.log(res.data.pagination);

                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
            });

    },

    deletePayments : async (context,settings) => {


        let url = "paymentmethods/delete";


        //console.log(context.rootGetters['categories/getSortBy'])
        return await   axios.post(`${context.rootGetters['settings/getUrl']}${url}`,
            {
                'data': {
                    "query": settings
                }
            },
            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            }
        )

            .then(res => {
                //console.log(res.data.pagination);
                //context.commit('setCategories', res.data.data);
                return res.data
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err.response.status);
                /*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }*/
                return {error:err.response.status}
                //throw Error(err.response.status);
            });

    },


    getDetailPayment : async (context,payload) =>{
        //console.log(payload)
        let url = `paymentmethods/detail/${payload}`;


        return await   axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },
        )

            .then(res => {
                //console.log(res);
                //context.commit('setCategoriesTree', res.data.data);
                return {data:res.data}
                //resolve(res);
            })
            .catch(err => {
                console.log("errore", err);
                /*  if (err.response.status === 401) {

                      //this.setLogout();
                      context.commit('profile/setLogout', {}, {root: true})
                      this.$router.push('/login')
                  }
                  throw Error(err.response.status + ":Posts Not Found");*/
            });
    },


    destroyData : (context) =>{
        context.commit('setPayments',[]);
        context.commit('setPayment',[]);



    },


};

const mutations = {
    setPayments: (state,value) => {
        state.payments= value;
    },
    setPayment: (state,value) => {
        state.payment= value;
    },
    setSortBy: (state,value) => {
        state.sortBy= value;
    },
    setIndex: (state,value) => {
        state.index= value;
    },
    setSortDesc: (state,value) => {
        state.sortDesc= value;
    }



};



export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}
